import { useEffect, useState } from "react";
import { ReactComponent as CarouselBase } from "../../assets/images/CarouselBase.svg";
import "../carouselNavigation/CarouselNavigation.css";
import "./ImageCarousel.css";

const ImageCarousel = ({ images, activeIndex, onImageClick }) => {
  const hasImages = images && images.length > 0;

  // Initialize state with activeIndex
  const [currentIndex, setCurrentIndex] = useState(() => {
    if (hasImages && activeIndex !== null && activeIndex < images.length) {
      return activeIndex;
    }
    return 0;
  });

  useEffect(() => {}, [images]);

  useEffect(() => {
    if (hasImages && activeIndex !== null && activeIndex < images.length) {
      setCurrentIndex(activeIndex);
    }
  }, [activeIndex, hasImages, images?.length]);

  const handlePrevClick = () => {
    if (!hasImages) return;
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    if (onImageClick) onImageClick(newIndex);
  };

  const handleNextClick = () => {
    if (!hasImages) return;
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    if (onImageClick) onImageClick(newIndex);
  };

  return (
    <div className="image-carousel">
      <div className="carousel-image-container">
        {hasImages && images[currentIndex] ? (
          <img
            src={images[currentIndex]}
            alt={`Carousel ${currentIndex + 1}`}
            className="carousel-image"
          />
        ) : null}
      </div>

      <div className="carousel-navigation">
        <CarouselBase className="carousel-base" />

        {/* Transparent buttons positioned over the arrows */}
        <button
          className="carousel-arrow-button carousel-prev-button"
          onClick={handlePrevClick}
          aria-label="Previous image"
        />
        <button
          className="carousel-arrow-button carousel-next-button"
          onClick={handleNextClick}
          aria-label="Next image"
        />
      </div>
    </div>
  );
};

export default ImageCarousel;
